// This is temp solution to put dirty code into one place,
// if you want to find bad code - search for split()

import { EPDDefinitionModel } from 'types/epd-definition/EPDDefinitionModel';
import { ISO_21930_ID } from './constants';
import { EpdVersionHistoryData } from './version-history/utils/EpdVersionHistoryDataContext';
import { PCRInformationModel } from 'types/types';

export function IsISO21930StandardCompliant(data?: EpdVersionHistoryData): boolean;
export function IsISO21930StandardCompliant(data?: EPDDefinitionModel): boolean;
export function IsISO21930StandardCompliant(data?: EpdVersionHistoryData | EPDDefinitionModel): boolean {
  if (!data) {
    return false;
  }

  const standards =
    'epdDefinitionInformation' in data
      ? data.epdDefinitionInformation.statementOfConformityWithStandards
      : data.statementOfConformityWithStandards;

  return standards?.toString().split(',').includes(ISO_21930_ID) ?? false;
}

export function IsPanelContentEnabled(pcrInformation?: PCRInformationModel): boolean {
  return pcrInformation?.cpcr?.registrationNumber?.toLocaleLowerCase()?.includes('c-pcr-014') || false;
}
